import { Link } from 'react-router-dom';
import { useAuth } from '@/App';
import { Zap, ArrowRight, LayoutDashboard } from 'lucide-react';
import MobileMenu from '@/components/MobileMenu';

export default function PublicNav() {
  const { user } = useAuth();

  return (
    <nav className="border-b bg-white px-4 md:px-8 py-4 sticky top-0 z-50 bg-white/90 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5">
          <img src="/flexa-wordmark.png" alt="Flexa" width="97" height="28" className="h-7 w-auto object-contain" />
        </Link>
        <div className="flex items-center gap-4 md:gap-6">
          <Link to="/services" className="text-sm text-[#6B7280] hover:text-[#0F172A] transition-colors hidden md:inline">Services</Link>
          <Link to="/blog" className="text-sm text-[#6B7280] hover:text-[#0F172A] transition-colors hidden md:inline">Blog</Link>
          <Link to="/faq" className="text-sm text-[#6B7280] hover:text-[#0F172A] transition-colors hidden md:inline">FAQ</Link>
          {user ? (
            <Link to="/dashboard" className="text-sm font-medium text-white bg-[#9333EA] hover:bg-[#7E22CE] px-4 py-2 rounded-lg transition-colors flex items-center gap-1.5">
              <LayoutDashboard className="h-3.5 w-3.5" /> Dashboard
            </Link>
          ) : (
            <>
              <Link to="/" className="hidden md:inline-flex text-sm font-medium text-[#6B7280] hover:text-[#9333EA] border border-[#E9D5FF] px-4 py-2 rounded-lg hover:border-[#9333EA] transition-colors">Log Masuk</Link>
              <Link to="/signup" className="text-sm font-medium text-white bg-[#9333EA] hover:bg-[#7E22CE] px-4 py-2 rounded-lg transition-colors flex items-center gap-1.5">
                Daftar <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            </>
          )}
          <MobileMenu />
        </div>
      </div>
    </nav>
  );
}
